
<template>
  <div v-if="data" v-wechat-title="title">

    <div v-if="data.commodity.length<=1" class="groupRectBase">
      <div class="title" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor">拼购商品
        <div class="topButton"><i class="iconfont iconback" @click="onBack" /></div>
      </div>
      <div class="commodityIcon about">
        <img :src="data.commodity[0].icon">
      </div>
    </div>
    <div v-if="data.commodity.length>1" class="groupRectBase">
      <div class="title" :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor">请选择商品
        <div class="topButton"><i class="iconfont iconback" @click="onBack" /></div>
      </div>
      <div class="commodityIconsRect about">
        <div v-for="item in data.commodity" :key="item.groupBuyCommodityId" class="icon" @click="onSelctCommodity(item.groupBuyCommodityId)">
          <img v-if="item.select" :src="item.icon" class="selected" :style="'border:1px solid '+data.team.baseColor">
          <img v-if="!item.select" :src="item.icon">
        </div>
      </div>
    </div>
    <div class="groupRectBase">
      <div
        v-if="(data.team.isBindName &&data.team.isNeedCertificate &&!data.userHaveCertificate)||data.team.isNeedNickName"
        class="title"
        :style="'background-color: '+data.team.baseColor+';color:'+data.team.fontColor"
      >请输入以下信息，核实潜水员身份</div>
      <template v-if="data.team.isBindName &&data.team.isNeedCertificate &&!data.userHaveCertificate">
        <div class="inputRect">
          <van-row>
            <van-col span="6" class="rigth">英文姓</van-col>
            <van-col span="18">
              <van-field v-model="formData.lastName" required placeholder="例如zhang" />
            </van-col>
          </van-row>
          <van-row>
            <van-col span="6" class="rigth">英文名</van-col>
            <van-col span="18">  <van-field v-model="formData.firstName" required placeholder="例如san feng" /></van-col>
          </van-row>
          <van-row>
            <van-col span="6" class="rigth">生日</van-col>
            <van-col span="18">  <van-field v-model="formData.birthday" required placeholder="请选择出生日期" @click="showBirthday=true" /></van-col>
          </van-row>
          <van-row>
            <van-col span="6" class="rigth">邮箱</van-col>
            <van-col span="18">  <van-field v-model="formData.email" placeholder="电子邮箱" /></van-col>
          </van-row>
        </div>
      </template>
      <div v-if="data.team.isNeedNickName" class="inputRect">
        <van-row>
          <van-col span="6" class="rigth">昵称</van-col>
          <van-col span="18"><van-field v-model="nickName" required placeholder="雕刻在印章上的昵称(英文)" @input="onNickNameChange" /></van-col>
        </van-row>
      </div>
    </div>

    <dateSelect v-model="showBirthday" @onChange="onBirthdayChange" />
    <followWx v-model="showFollow" @finish="buttonDisable=false" />
    <div class="groupDownButton">
      <van-button type="default" size="large" :disabled="buttonDisable" :loading="buttonLoading" :color="data.team.baseColor" @click="onGoNext">下一步</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Dialog, Toast } from 'vant'
import dateSelect from '@/components/dateSelect'
import { MyNotify, checkUserLastName, getUrlKey } from '@/utils/base'
import Cookies from 'js-cookie'
import followWx from '@/components/followWx'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    dateSelect,
    followWx
  },
  data() {
    return {
      title: '拼团购',
      system: undefined,
      backurl: '/store/index',
      buttonLoading: false,
      key: undefined,
      data: undefined,
      selectDate: undefined,
      showBirthday: false,
      selectCommodity: undefined,
      formData: {
        lastName: '',
        firstName: '',
        birthday: '',
        email: '',
        url: ''
      },
      nickName: '',
      toastLoading: undefined,
      waitTime: 0,
      waitTimer: undefined,
      buttonDisable: true,
      showFollow: false,
      isSearching: false
    }
  },
  created() {
    this.key = this.$route.params.key
    this.system = getUrlKey('system')
    if (Cookies.get('GroupNickName_')) {
      this.nickName = Cookies.get('GroupNickName_')
    }
    this.init()
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  methods: {
    onNickNameChange(value) {
      Cookies.set('GroupNickName_', value)
    },
    onBirthdayChange(date) {
      console.log('selectDate', date)
      this.formData.birthday = date
    },
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        setTimeout(() => {
          this.showFollow = true
        }, 10)
        this.data = response.data
        this.title = this.data.team.shortName
        this.data.commodity.forEach(item => {
          item.select = false
        })
        if (this.data.commodity.length === 1) {
          this.data.commodity[0].select = true
          this.selectCommodity = this.data.commodity[0].groupBuyCommodityId
        }

        if (this.data.commodity.length === 1 && !this.data.team.isNeedNickName) {
          if (this.data.team.isNeedCertificate) {
            if (this.data.team.userHaveCertificate) {
              this.$router.push('/group/groupAddress/' + this.key + '?commodity=' + this.selectCommodity)
            }
          } else {
            this.$router.push('/group/groupAddress/' + this.key + '?commodity=' + this.selectCommodity)
          }
        }
      })
    },
    onSelctCommodity(id) {
      this.data.commodity.forEach(item => {
        item.select = item.groupBuyCommodityId === id
      })
      this.data.commodity = JSON.parse(JSON.stringify(this.data.commodity))
    },
    onBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/group/groupCommodity/' + this.key)
    },
    onGoNext() {
      this.selectCommodity = undefined
      this.data.commodity.forEach(item => {
        if (item.select) {
          this.selectCommodity = item.groupBuyCommodityId
        }
      })

      if (!this.selectCommodity) {
        MyNotify('error', '请选择一个商品')
        return
      }
      if (this.data.team.isNeedNickName) {
        if (this.nickName.length < 1) {
          MyNotify('error', '请输入昵称(英文)')
          return
        }
        if (/.*[\u4e00-\u9fa5]+.*$/.test(this.nickName)) {
          MyNotify('error', '昵称不能含有汉字')
          return
        }
      }
      if (this.data.userHaveCertificate) {
        this.$router.push('/group/groupAddress/' + this.key + '?commodity=' + this.selectCommodity)
        return
      }

      if (!this.data.userHaveCertificate) {
        if (this.formData.lastName.length < 1) {
          MyNotify('error', '例如zhang')
          return
        }
        if (this.formData.firstName.length < 1) {
          MyNotify('error', '例如san feng')
          return
        }
        if (this.formData.birthday.length < 1) {
          MyNotify('error', '请选择生日')
          return
        }
        let EmailStr = ''
        if (this.formData.email.length > 0) {
          EmailStr = '\n邮箱:' + this.formData.email
        }
        checkUserLastName(this.formData.firstName, () => {
          Dialog.confirm({
            title: '核对姓名',
            message: '请核对您的英文姓:' + this.formData.lastName + '\n名:' + this.formData.firstName + '\n生日:' + this.formData.birthday + EmailStr + '\n是否正确,一旦提交无法修改!'
          }).then(() => {
            this.onPostData()
          })
        })
      }
    },
    onPostData() {
      this.buttonLoading = true
      this.formData.url = GetSelfUrl() + 'group/groupCommodity/' + this.key + '?system=' + this.system
      request({
        url: '/user/updateUserNameBirthday',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          Dialog.alert({
            title: '提交失败',
            message: response.data
          }).then(() => {
          })
          return
        }
        this.onWait()
      })
    },
    onWait() {
      this.waitTime = 180
      this.toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
      })
      this.waitTimer = setInterval(() => {
        this.waitTime--
        if (this.waitTime > 0 && this.waitTime < 160) {
          this.toastLoading.message = '目前核实身份人数较多，您可以关闭页面，核实成功后，将以公众号通知形式邀请您参与活动[' + this.waitTime + '秒]!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else if (this.waitTime > 0) {
          this.toastLoading.message = '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.confirm({
            title: '未能完成检查',
            message: '非常抱歉，我们尚未能完成对您资质证书的检查，稍后查询完成我们将会给你发送推送通知，您是否现在继续等待?'
          }).then(() => {
            this.onWait()
          })
        }
      }, 1000)
    },
    onCheckFinish() {
      request({
        url: '/user/getUserHaveCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data.have) {
          clearInterval(this.waitTimer)
          Toast.clear()
          this.$router.push('/group/groupAddress/' + this.key + '?commodity=' + this.selectCommodity)
        } else if (response.data.finish) {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.alert({
            title: '未查询到您的潜水资质',
            message: '未能查询到您拥有潜水员资质，请检查您输入的英文(拼音)姓名、出生日期、邮箱是否正确。'
          }).then(() => {

          })
        }
      })
    }
  }
}
</script>
<style scoped>
.commodityIcon{
    width: 100%;
    text-align: center;
}
.commodityIcon img{
    width: 80%;
}
.commodityIconsRect {
    width: 82%;
    padding-left: 10%;
    display:flex;
    flex-flow: wrap;
}
.commodityIconsRect .icon{
    width: 50%;
    text-align: center;
}
.commodityIconsRect .icon img{
    border:1px solid #ccc;
    width: 92%;
    margin-bottom: 4%;
}

 .inputRect{
    line-height: 44px;
}
 .inputRect div{
    margin:0.1em 0 0 0;
}

.inputRect .annotation{
  line-height: 20px;
  font-size: 0.8em;
  margin-left: 1em;
}
</style>
